/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlPasswordResetRequest
 */
export interface ControlPasswordResetRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlPasswordResetRequest
     */
    email: string;
}

/**
 * Check if a given object implements the ControlPasswordResetRequest interface.
 */
export function instanceOfControlPasswordResetRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function ControlPasswordResetRequestFromJSON(json: any): ControlPasswordResetRequest {
    return ControlPasswordResetRequestFromJSONTyped(json, false);
}

export function ControlPasswordResetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPasswordResetRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function ControlPasswordResetRequestToJSON(value?: ControlPasswordResetRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

